export default __webpack_public_path__ + "static/the-differance-is-clear-video-landscape-fr-e97509c1b75c80c1fa0764237faede84.mp4";